export function getStartAt(pass, book) {
  if (pass.is_valid) {
    return pass.user_started_at;
  }
  return book.user_started_at || book.available_started_at;
}
